import { render, staticRenderFns } from "./BrandVatEdit.vue?vue&type=template&id=8cf46fd8&"
import script from "./BrandVatEdit.vue?vue&type=script&lang=js&"
export * from "./BrandVatEdit.vue?vue&type=script&lang=js&"
import style0 from "./BrandVatEdit.vue?vue&type=style&index=0&id=8cf46fd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports